export const SERVICE_CODE = 'USER' + '_SERVICE';
